import React from 'react';
export default function QuestionProgressBar({ value, maxValue, }) {
    return (React.createElement("div", { className: "w-36 h-1 bg-darkBlue/10 rounded mx-auto" },
        React.createElement("div", { className: "h-full bg-green rounded", style: { width: `${(value / maxValue) * 100}%` } })));
}
